
import { installPassport, isInHospEnv, isProd } from '../services/base';
import { defineComponent, onMounted, reactive } from 'vue';
import { getLoginPageConfig, isShowLinkdocText } from '../services/serviceA';
import { LoginBox } from '@linkdoc/uc-loginbox';
import PrivateLogin from './PrivateLogin.vue';
import { isNuc } from '@/utils/env';

export default defineComponent({
  components: {
    LoginBox,
    PrivateLogin
  },
  setup() {
    interface LoginState {
      title: string;
      core: string;
      logo: string;
      isInHospEnv: boolean;
    }
    const showLinkdocText = isShowLinkdocText();
    const currentYear = new Date().getFullYear();
    const state = reactive<LoginState>({
      title: '',
      core: '',
      logo: '',
      isInHospEnv: !!isInHospEnv,
    });

    onMounted(() => {
      getLoginPageConfig().then(res => {
        if (res.success) {
          const data = res.data;
          state.title = 'NF1 神经纤维瘤病临床研究数据平台';
          state.core = '提供符合医生习惯的 NF1 疾病数据采集、管理及科研应用的一站式服务';
          state.logo = data.logo;

          if (isInHospEnv) {
            // 私有化部署
          } else {
            // 云端部署 注册登录窗
            if (isProd()) {
              installPassport();
            }
          }
        }
      });
    });

    return {
      currentYear,
      showLinkdocText,
      state,
      isNuc,
    };
  }
});
